import React from 'react'
import { Row, RowProps } from 'antd'

import { theme } from './theme'

type TFormItemUIGroupProps = {
  children: React.ReactNode
  rowProps?: RowProps
}

export default function FormItemUIGroup({
  children,
  rowProps,
}: TFormItemUIGroupProps) {
  return (
    <Row gutter={[theme.itemHorizontalSpacing, 16]} {...rowProps}>
      {children}
    </Row>
  )
}
